import styles from './index.less';
import { FC } from 'react';
import robot from '@/assets/home/house.png';
import { Divider, Space, Tag, Image } from 'react-vant';
import {
  publishAuditStatusEnum,
  publishAuditStatusMap,
  publishAuditStatusTagType,
  rendAndSaleEnum,
} from '@/pages/ServicesMore/config';
import {
  useNavigate,
  // history,
} from '@umijs/max';
import { Phone } from '@react-vant/icons';

type rendAndSaleListItemType = {
  sequenceNbr: number;
  duration: string;
  type?: string;
  communityName?: string;
  price: number;
  phone: string;
  tag?: string[];
  layout?: string;
  area: string;
  title: string;
  rentType?: string;
  facing?: string;
  roomType?: string;
  decoration?: string;
  minBudget?: string;
  maxBudget?: string;
  // auditStatus: publishAuditStatusEnum;
};

type HouseRendAndSaleListContainerProps = {
  rendAndSaleListItem: rendAndSaleListItemType;
  type: rendAndSaleEnum;
};

const HouseRendAndSaleListContainer: FC<HouseRendAndSaleListContainerProps> = (
  props,
) => {
  const { rendAndSaleListItem, type } = props;
  const navigate = useNavigate();

  const jumpToDetail = () => {
    console.log(rendAndSaleListItem.sequenceNbr, 'rendAndSaleListItem');
    // history.push('/publishDetail');
    navigate('/publishDetail', {
      state: {
        publishId: rendAndSaleListItem.sequenceNbr,
      },
    });
  };

  return (
    <div onClick={jumpToDetail} className={styles.container}>
      {/* <img src={robot} alt={'robot'} /> */}
      <Image lazyload height="100" fit='cover' width="100" src={robot} style={{ 'margin-left': '5px', }}/>

      <div className={styles.content}>
        <section className={styles.title}>
          <span>{rendAndSaleListItem.rentType}</span>
          <span className={styles.titleText}> {rendAndSaleListItem.title}</span>
          {/* {type === rendAndSaleEnum.MINE && (
            <Tag
              type={
                publishAuditStatusTagType[rendAndSaleListItem.auditStatus] || ''
              }
            >
              {publishAuditStatusMap[rendAndSaleListItem.auditStatus]}
            </Tag>
          )} */}
        </section>
        <section className={styles.communityText}>
          {rendAndSaleListItem.communityName}
        </section>
        <section className={styles.tag}> 
          <Space gap={8}>
            <Tag round   textColor={'#666'} color={'#ccc'} style={{ '--rv-tag-padding': '4px' }}>
              {rendAndSaleListItem.facing}
            </Tag>
            <Tag round  textColor={'#fff'} type="success" style={{ '--rv-tag-padding': '4px' }}>
              {rendAndSaleListItem.roomType}
            </Tag>
            <Tag round  textColor={'#fff'} type="warning" style={{ '--rv-tag-padding': '4px' }}>
              {rendAndSaleListItem.decoration}
            </Tag>
          </Space>
        </section> 
        <section className={styles.priceContent}>
            <span className={styles.price}>
              {rendAndSaleListItem?.type === '1' || rendAndSaleListItem?.type === '2' ? rendAndSaleListItem?.price : `${rendAndSaleListItem?.minBudget || 0}~${rendAndSaleListItem?.maxBudget || 0}`}
              {rendAndSaleListItem?.type === '1' || rendAndSaleListItem?.type === '2' ? '元/月' : '元'}
            </span>
        </section>
        <section className={styles.priceContent}>
          {/* <span className={styles.price}>
            {rendAndSaleListItem.price}
            
            <span style={{ fontSize: 12, marginLeft: 2 }}>元</span>
          </span> */}
           
          {type !== rendAndSaleEnum.SALE && (
            <Space divider={<Divider type="vertical" />} gap={8}>
              <span className={styles.houseType}>
                {rendAndSaleListItem.layout}
              </span>
              <span className={styles.area}>{rendAndSaleListItem.area}/㎡</span>
            </Space>
          )}

          {type === rendAndSaleEnum.SALE && (
            <span className={styles.phone}><Phone  />{rendAndSaleListItem.phone}</span>
          )}
        </section>
      </div>
    </div>
  );
};

export default HouseRendAndSaleListContainer;
